import z from 'zod'

export const frenchNumberSchema = z.preprocess(
  (val) => (typeof val === 'string' ? val.replace(',', '.') : val),
  z.coerce.number('La valeur doit être un nombre'),
)

/**
 * Plafond de production optionnel : `''` = sans limite (la chaîne vide, et non
 * null, survit au transport multipart — cf. `useProductForm`), sinon un ENTIER
 * STRICTEMENT POSITIF — mêmes règles que le serveur
 * (`vine.number().positive().withoutDecimals()`), pour refuser « 0 » ou « 12,5 »
 * dès la saisie plutôt qu'en 422 à la dernière page du formulaire.
 */
export const optionalProductionCapSchema = z.preprocess(
  (value) => (value === null || value === undefined ? '' : value),
  z
    .literal('')
    .or(
      frenchNumberSchema.pipe(
        z
          .number()
          .int('Le plafond doit être un nombre entier')
          .positive('Le plafond doit être strictement positif'),
      ),
    ),
)

export const coefSecuSchema = z.preprocess(
  (value) => (value === null || value === undefined || value === '' ? 1 : value),
  frenchNumberSchema.pipe(
    z
      .number()
      .min(0.5, 'Le coefficient doit être au minimum de 0,5')
      .max(5, 'Le coefficient doit être au maximum de 5'),
  ),
)

export const requiredFrenchNumberSchema = z
  .any()
  .refine(
    (value) => value !== null && value !== undefined && String(value).trim() !== '',
    'Ce champ est obligatoire',
  )
  .pipe(frenchNumberSchema)
